import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header.component.media.scss']
})
export class HeaderComponent implements OnInit {
  navList = [
    {
      label: 'Home Page',
      path: ''
    },
    {
      label: 'About Us',
      path: 'intro',
      dropdown: true,
      src: './assets/company.jpg',
      list: [
        {
          label: 'Intro',
          path: 'intro',
          extra: {
            fragment: 'intro'
          }
        },
        {
          label: 'Development',
          path: 'intro',
          extra: {
            fragment: 'development'
          }
        },
        {
          label: 'Organization',
          path: 'intro',
          extra: {
            fragment: 'zuzhi'
          }
        }
      ],
      content: '宁波市北仑华日金属制品有限公司，是一家集模具设计制造，精密机械加工，锌、铝合金压铸和电镀为一体的股份制企业，公司主要制造通讯、汽摩、灯具、电器、锁具、电机壳、五金等行业的各类精密产品，以及表面处理。'
    },
    {
      label: 'Products',
      path: 'product',
      dropdown: true,
      src: './assets/company.jpg',
      list: [
        {
          label: 'Auto Parts',
          path: 'product',
          extra: {
            queryParams: {
              ind: 0
            },
            fragment: 'look'
          }
        },
        {
          label: 'Communication',
          path: 'product',
          extra: {
            queryParams: {
              ind: 1
            },
            fragment: 'look'
          }
        },
        {
          label: 'Electric Power',
          path: 'product',
          extra: {
            queryParams: {
              ind: 2
            },
            fragment: 'look'
          }
        },
        {
          label: 'Lamp',
          path: 'product',
          extra: {
            queryParams: {
              ind: 3
            },
            fragment: 'look'
          }
        },
        {
          label: 'Precision',
          path: 'product',
          extra: {
            queryParams: {
              ind: 4
            },
            fragment: 'look'
          }
        },
        {
          label: 'Surface',
          path: 'product',
          extra: {
            queryParams: {
              ind: 5
            },
            fragment: 'look'
          }
        },
        {
          label: 'Mould',
          path: 'product',
          extra: {
            queryParams: {
              ind: 6
            },
            fragment: 'look'
          }
        }
      ],
      content: '宁波市北仑华日金属制品有限公司，是一家集模具设计制造，精密机械加工，锌、铝合金压铸和电镀为一体的股份制企业，公司主要制造通讯、汽摩、灯具、电器、锁具、电机壳、五金等行业的各类精密产品，以及表面处理。'
    },
    {
      label: 'R & D Ability',
      path: 'development',
      dropdown: true,
      src: './assets/company.jpg',
      list: [
        {
          label: 'Technology',
          path: 'development',
          extra: {
            fragment: 'tech'
          }
        },
        {
          label: 'Management',
          path: 'development',
          extra: {
            fragment: 'quality'
          }
        }
      ],
      content: '宁波市北仑华日金属制品有限公司，是一家集模具设计制造，精密机械加工，锌、铝合金压铸和电镀为一体的股份制企业，公司主要制造通讯、汽摩、灯具、电器、锁具、电机壳、五金等行业的各类精密产品，以及表面处理。'
    },
    {
      label: 'Quality',
      path: 'factory',
      dropdown: true,
      src: './assets/company.jpg',
      list: [
        {
          label: 'Assurance',
          path: 'factory',
          extra: {
            fragment: 'tech'
          }
        },
        {
          label: 'Equipment',
          path: 'factory',
          extra: {
            fragment: 'quality'
          }
        }
      ],
      content: '宁波市北仑华日金属制品有限公司，是一家集模具设计制造，精密机械加工，锌、铝合金压铸和电镀为一体的股份制企业，公司主要制造通讯、汽摩、灯具、电器、锁具、电机壳、五金等行业的各类精密产品，以及表面处理。'
    },
    {
      label: 'Sales',
      path: 'net',
      dropdown: true,
      src: './assets/company.jpg',
      list: [
        {
          label: 'Exhibition',
          path: 'net',
          extra: {
            fragment: 'show'
          }
        },
        {
          label: 'Network',
          path: 'net',
          extra: {
            fragment: 'net'
          }
        },
        {
          label: 'Customers',
          path: 'net',
          extra: {
            fragment: 'customer'
          }
        }
      ],
      content: '宁波市北仑华日金属制品有限公司，是一家集模具设计制造，精密机械加工，锌、铝合金压铸和电镀为一体的股份制企业，公司主要制造通讯、汽摩、灯具、电器、锁具、电机壳、五金等行业的各类精密产品，以及表面处理。'
    },
    {
      label: 'Contact US',
      path: 'contact'
    }
  ];
  showMenu = false;
  constructor(private router: Router) { }

  ngOnInit() {
  }
  handleShowMenu() {
    this.showMenu = !this.showMenu;
  }
  handleGoPath(path) {
    this.showMenu = false;
    this.router.navigateByUrl(path)
  }
  handleScroll(e) {
    console.log('e', e);
    e.stopPropagation();
  }
  goNav(c) {
    console.log(111);
    this.router.navigate([c.path], c.extra);
  }
}
